import React, { useEffect, useState } from "react";
import axios from 'axios';
import { Box, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X"; // Or use TwitterIcon if preferred

// const socialLinks = [
//   { name: "X", url: "https://twitter.com", icon: <XIcon /> },
//   { name: "Instagram", url: "https://instagram.com", icon: <InstagramIcon /> },
//   { name: "YouTube", url: "https://youtube.com", icon: <YouTubeIcon /> },
//   { name: "LinkedIn", url: "https://linkedin.com", icon: <LinkedInIcon /> },
//   { name: "Facebook", url: "https://facebook.com", icon: <FacebookIcon /> },
// ];

interface Props {
  visible?: boolean;
}

export const FloatingSocialButtonRow: React.FC<Props> = ({ visible = true }) => {
    type GroupTextItem = {
      id: number;
      Name: string;
      Link: string;
      bgcolor: string;
      Icon: {
        url: string;
      }[];
    };


  const [socialLink, setSocialLink] = useState<GroupTextItem[]>([]);
  const BASE_URL = "https://app.dfopsa.online";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/social?populate[SocialLink][populate]=*`);

        const groupSocialLink = res?.data?.data?.SocialLink || [];
        setSocialLink(groupSocialLink);
      } catch (error) {
        console.error('Failed to fetch statistic data:', error);
      }
    };

    fetchData();
  }, []);

  if (!visible) return null;

  // return (
  //   <Box
  //     sx={{
  //       position: "fixed",
  //       top: "30%",
  //       right: 0, 
  //       display: "flex",
  //       flexDirection: "column",
  //       alignItems: "center",
  //       gap: 2,
  //       px: 1,
  //       zIndex: 1300,
  //     }}
  //   >
  //     {socialLink.map((link) => (
  //       <IconButton
  //         key={link?.Name}
  //         component="a"
  //         href={link?.Link}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         sx={{
  //           backgroundColor: `${link.bgcolor}`, 
  //           color: "#fff",
  //           width: 56,
  //           height: 56,
  //           borderRadius: "50%",
  //           boxShadow: `0 0 12px 4px ${link.bgcolor}`, 
  //           "&:hover": {
  //             backgroundColor: "#388E3C", 
  //           },
  //         }}
  //       >
  //             {link.Icon && (
  //               <img
  //                 src={`https://app.dfopsa.online${link.Icon[0]?.url}`}
  //                 alt="Icon"
  //                 width={40}
  //                 height={40}
  //               />
  //             )}
  //       </IconButton>
  //     ))}
  //   </Box>
  // );
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 2,
        mt: 4,
        flexWrap: "wrap", // optional: for responsiveness
      }}
    >
      {socialLink.map((link) => (
        <IconButton
          key={link.id}
          component="a"
          href={link.Link}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: link.bgcolor,
            color: "#fff",
            width: 56,
            height: 56,
            borderRadius: "0%",
            // boxShadow: `0 0 12px 4px ${link.bgcolor}`,
            "&:hover": {
              backgroundColor: "#388E3C",
            },
          }}
        >
          {link.Icon?.[0]?.url && (
            <img
              src={`${BASE_URL}${link.Icon[0].url}`}
              alt={link.Name}
              width={40}
              height={40}
              style={{ objectFit: "contain" }}
            />
          )}
        </IconButton>
      ))}
    </Box>
  );
};

